import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientCompanyEntity } from './client-company.entity';
import { ClientEntity } from './client.entity';
import { CompanyGoalEntity } from './company-goal.entity';
import { CompanyPreferenceEntity } from './company-preference.entity';
import { CompanyWarehouseEntity } from './company-warehouse.entity';
import { InvoiceEntity } from './invoice.entity';
import { ItemCompanyEntity } from './item-company.entity';
import { ItemEntity } from './item.entity';
import { MPaymentTransactionEntity } from './m-payment-transaction.entity';
import { OrderEntity } from './order.entity';
import { PaymentProcessorConfigEntity } from './payment-processor-config.entity';
import { PriceContractEntity } from './price-contract.entity';
import { PurchaseOrderReceiptEntity } from './purchase-order-receipt.entity';
import { PurchaseOrderEntity } from './purchase-order.entity';
import { ShipmentEntity } from './shipment.entity';
import { ShippingMethodCompanyEntity } from './shipping-method-company.entity';
import { SupportedPaymentMethodTypeEntity } from './supported-payment-method-type.entity';
import { UserCompanyEntity } from './user-company.entity';
import { VendorEntity } from './vendor.entity';

@Index('company_externalId_uindex', ['externalId'], { unique: true })
@Entity('company')
export class CompanyEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('varchar', { name: 'name', length: 64 })
	public name!: string;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@OneToMany(() => ClientEntity, (client) => client.fkCompanyIdPrimary2)
	public clients!: Array<ClientEntity>;

	@OneToMany(
		() => ClientCompanyEntity,
		(clientCompany) => clientCompany.fkCompany,
	)
	public clientCompanies!: Array<ClientCompanyEntity>;

	@OneToMany(() => CompanyGoalEntity, (companyGoal) => companyGoal.fkCompany)
	public companyGoals!: Array<CompanyGoalEntity>;

	@OneToMany(
		() => CompanyPreferenceEntity,
		(companyPreference) => companyPreference.fkCompany,
	)
	public companyPreferences!: Array<CompanyPreferenceEntity>;

	@OneToMany(
		() => CompanyWarehouseEntity,
		(companyWarehouse) => companyWarehouse.fkCompany,
	)
	public companyWarehouses!: Array<CompanyWarehouseEntity>;

	@OneToMany(() => InvoiceEntity, (invoice) => invoice.fkCompany)
	public invoices!: Array<InvoiceEntity>;

	@OneToMany(() => ItemEntity, (item) => item.primaryCompany)
	public items!: Array<ItemEntity>;

	@OneToMany(() => ItemCompanyEntity, (itemCompany) => itemCompany.company)
	public itemCompanies!: Array<ItemCompanyEntity>;

	@OneToMany(
		() => MPaymentTransactionEntity,
		(mPaymentTransaction) => mPaymentTransaction.mSmPaymentFkCompany,
	)
	public transactions!: Array<MPaymentTransactionEntity>;

	@OneToMany(() => OrderEntity, (order) => order.fkCompany)
	public orders!: Array<OrderEntity>;

	@OneToMany(
		() => PaymentProcessorConfigEntity,
		(paymentProcessorConfig) => paymentProcessorConfig.fkCompany,
	)
	public paymentProcessorConfigs!: Array<PaymentProcessorConfigEntity>;

	@OneToMany(
		() => SupportedPaymentMethodTypeEntity,
		(supportedPaymentMethodType) => supportedPaymentMethodType.fkCompany,
	)
	public supportedPaymentMethodTypes!: Array<SupportedPaymentMethodTypeEntity>;

	@OneToMany(
		() => PriceContractEntity,
		(priceContract) => priceContract.company,
	)
	public priceContracts!: Array<PriceContractEntity>;

	@OneToMany(
		() => PurchaseOrderEntity,
		(purchaseOrder) => purchaseOrder.fkCompany,
	)
	public purchaseOrders!: Array<PurchaseOrderEntity>;

	@OneToMany(
		() => PurchaseOrderReceiptEntity,
		(purchaseOrderReceipt) => purchaseOrderReceipt.fkCompany,
	)
	public purchaseOrderReceipts!: Array<PurchaseOrderReceiptEntity>;

	@OneToMany(() => ShipmentEntity, (shipment) => shipment.fkCompany)
	public shipments!: Array<ShipmentEntity>;

	@OneToMany(() => ShippingMethodCompanyEntity, (smc) => smc.company)
	public shippingMethodCompanies!: Array<ShippingMethodCompanyEntity>;

	@OneToMany(() => UserCompanyEntity, (userCompany) => userCompany.fkCompany)
	public userCompanies!: Array<UserCompanyEntity>;

	@OneToMany(() => VendorEntity, (vendor) => vendor.fkCompany)
	public vendors!: Array<VendorEntity>;
}
